import { TicketInternalStatus } from "shared/types/helpdesk";
import { PickerItemProps } from "../../types";
import { ActivityIcon } from "@phosphor-icons/react";
import { helpdeskPhaseColumns } from "screens/helpdesk/helpdeskPhaseConfig";

export const HelpdeskStatusItem = ({
  item,
  isSelected,
  onSelect,
}: PickerItemProps<TicketInternalStatus>) => {
  // Find the phase column configuration for this status
  const phaseConfig = helpdeskPhaseColumns.find((col) => col.id === item);
  const label = phaseConfig?.label || item;
  const colorClasses = phaseConfig?.color || "text-gray-700";
  const bgColorClasses = phaseConfig?.bgColor || "bg-gray-50";

  return (
    <button
      onClick={() => onSelect(item)}
      className={`flex w-full items-center gap-3 rounded-lg border px-4 py-3 text-left text-sm shadow-sm transition-all duration-200 ease-in-out hover:scale-[1.01] hover:shadow-md active:scale-[0.99] ${
        isSelected
          ? "bg-purple-primary/10 text-purple-primary border-purple-primary/40 ring-purple-primary/20 ring-2"
          : `${bgColorClasses} ${colorClasses} border-current/20 hover:border-current/40 hover:ring-2 hover:ring-current/10`
      }`}
    >
      <div className="shrink-0">
        <ActivityIcon weight="duotone" size={18} />
      </div>
      <span className="flex-1 font-semibold">{label}</span>
    </button>
  );
};
